import { useEffect, useRef } from 'react';
import axios from 'axios';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Lightweight usage signal: one ping per page change, one heartbeat a minute while the tab is visible.
export const useUsageTracker = () => {
  const { user, getAuthHeader } = useAuth();
  const location = useLocation();
  const headerRef = useRef(getAuthHeader);
  headerRef.current = getAuthHeader;
  const enabled = !!user && !user.impersonated_by;

  useEffect(() => {
    if (!enabled) return;
    axios.post(`${API_URL}/activity/ping`, { path: location.pathname, kind: 'view' }, { headers: headerRef.current() }).catch(() => {});
  }, [enabled, location.pathname]);

  useEffect(() => {
    if (!enabled) return;
    const id = setInterval(() => {
      if (document.visibilityState !== 'visible') return;
      axios.post(`${API_URL}/activity/ping`, { path: window.location.pathname, kind: 'heartbeat' }, { headers: headerRef.current() }).catch(() => {});
    }, 60000);
    return () => clearInterval(id);
  }, [enabled]);
};
